import Bugsnag from "@bugsnag/js";

export const errorLoggerWrapper = () => {
  return Bugsnag;
};
